export default function (element, data) {
    element.addEventListener("click", function () {
        const eventName = data.event;
        const eventDetail = data.eventDetail;

        const event = new CustomEvent(eventName, { detail: eventDetail });
        window.dispatchEvent(event);
    });
};